
import { get, post } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取自然拼读列表
    async getWordPingDuType(context, params) {
      const res = await get('/Study/aiWord/getWordPingDuType', params)
      return res
    },
    // 获取拼读视频
    async getPingDuVideoByType(context, params) {
      const res = await get('/Study/aiWord/getPingDuVideoByType', params)
      return res
    },
    // 获取音标列表详情
    async getYinBiaoInfoByType(context, params) {
      const res = await get('/Study/aiWord/getYinBiaoInfoByType', params)
      return res
    },
    // 获取视频列表
    async listAlbumVideos(context, params) {
      const res = await get('/Study/zo-product-album/listAlbumVideos', params)
      return res
    },
    // 获取视频播放url
    async getUrlEnBo(context, params) {
      // const res = await post('/Api/tools/web/play/video/url/get', params)
      const res = await post('/Study/tools/web/play/video/url/get', params)
      return res
    }

  }
}
